module.exports = __webpack_public_path__ + "168292c07505d0cbd7c83f0ec40c745e.svg";